/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export const i18n = {
    tabPresets: {
        ru: 'Пресет', en: 'Preset', es: 'Preset', pt: 'Preset',
        de: 'Preset', fr: 'Préréglage', th: 'พรีเซ็ต', ko: '프리셋', zh: '预设', ja: 'プリセット', hi: 'प्रीसेट'
    },
    tabColor: {
        ru: 'Цвет', en: 'Color', es: 'Color', pt: 'Cor',
        de: 'Farbe', fr: 'Couleur', th: 'สี', ko: '색상', zh: '颜色', ja: '色', hi: 'रंग'
    },
    tabRoller: {
        ru: 'Валик', en: 'Roller', es: 'Rodillo', pt: 'Rolo',
        de: 'Rolle', fr: 'Rouleau', th: 'ลูกกลิ้ง', ko: '롤러', zh: '滚筒', ja: 'ローラー', hi: 'रोलर'
    },
    tabCaps: {
        ru: 'Кэпы', en: 'Caps', es: 'Boquillas', pt: 'Bicos',
        de: 'Caps', fr: 'Caps', th: 'หัวสเปรย์', ko: '캡', zh: '喷嘴', ja: 'キャップ', hi: 'कैप'
    },
    toastSaving: {
        ru: 'Сохраняем на сервере...', en: 'Saving to cloud...', es: 'Guardando en la nube...', pt: 'Salvando na nuvem...',
        de: 'Auf dem Server speichern...', fr: 'Sauvegarde sur le cloud...', th: 'กำลังบันทึกลงในเซิร์ฟเวอร์...', ko: '서버에 저장 중...', zh: '正在保存到服务器...', ja: 'サーバーに保存中...', hi: 'सर्वर पर सहेज रहे हैं...'
    },
    toastSaved: {
        ru: 'Стена залита на сервак 🚀', en: 'Wall tagged to the cloud 🚀', es: 'Muro grafiteado en la nube 🚀', pt: 'Muro salvo na nuvem 🚀',
        de: 'Wand auf Server hochgeladen 🚀', fr: 'Mur sauvegardé sur le cloud 🚀', th: 'บันทึกกำแพงลงในเซิร์ฟเวอร์แล้ว 🚀', ko: '벽이 서버에 성공적으로 저장되었습니다 🚀', zh: '墙面已成功保存到服务器 🚀', ja: '壁がサーバーに保存されました 🚀', hi: 'दीवार सर्वर पर सहेज ली गई है 🚀'
    },
    toastSaveError: {
        ru: 'Ошибка сохранения 🚨', en: 'Save failed 🚨', es: 'Error al guardar 🚨', pt: 'Erro ao salvar 🚨',
        de: 'Fehler beim Speichern 🚨', fr: 'Échec de la sauvegarde 🚨', th: 'เกิดข้อผิดพลาดในการบันทึก 🚨', ko: '저장 실패 🚨', zh: '保存失败 🚨', ja: '保存に失敗しました 🚨', hi: 'सहेजने में विफल 🚨'
    },
    toastResetSuccess: {
        ru: 'Стена сброшена 🧹', en: 'Wall has been reset 🧹', es: 'El muro ha sido reiniciado 🧹', pt: 'O muro foi resetado 🧹',
        de: 'Wand wurde zurückgesetzt 🧹', fr: 'Le mur a été réinitialisé 🧹', th: 'รีเซ็ตกำแพงแล้ว 🧹', ko: '벽이 초기화되었습니다 🧹', zh: '墙壁已重置 🧹', ja: '壁がリセットされました 🧹', hi: 'दीवार रीसेट हो गई है 🧹'
    },
    toastResetError: {
        ru: 'Ошибка сброса 🚨', en: 'Reset failed 🚨', es: 'Error al reiniciar 🚨', pt: 'Erro ao resetar 🚨',
        de: 'Zurücksetzen fehlgeschlagen 🚨', fr: 'Échec de la réinitialisation 🚨', th: 'เกิดข้อผิดพลาดในการรีเซ็ต 🚨', ko: '초기화 실패 🚨', zh: '重置失败 🚨', ja: 'リセットに失敗しました 🚨', hi: 'रीसेट करने में विफल 🚨'
    },
    toastNetworkError: {
        ru: 'Ошибка мультиплеера: сеть перегружена', en: 'Multiplayer error: network overloaded', es: 'Error de multijugador: red sobrecargada', pt: 'Erro de multijogador: rede sobrecarregada',
        de: 'Multiplayer-Fehler: Netzwerk überlastet', fr: 'Erreur multijoueur : réseau surchargé', th: 'ข้อผิดพลาดมัลติเพลเยอร์: เครือข่ายหนาแน่น', ko: '멀티플레이어 오류: 네트워크 과부하', zh: '多人游戏错误：网络拥载', ja: 'マルチプレイヤーエラー：ネットワークが混雑しています', hi: 'मल्टीप्लेयर त्रुटि: नेटवर्क ओवरलोडेड'
    },
    pickerTabMarket: {
        ru: 'Маркет', en: 'Market', es: 'Mercado', pt: 'Mercado',
        de: 'Markt', fr: 'Marché', th: 'ตลาด', ko: '마켓', zh: '市场', ja: 'マーケット', hi: 'बाज़ार'
    },
    pickerTabCustom: {
        ru: 'Кастом', en: 'Custom', es: 'Personalizado', pt: 'Personalizado',
        de: 'Benutzerdefiniert', fr: 'Personnalisé', th: 'กำหนดเอง', ko: '커스텀', zh: '自定义', ja: 'カスタム', hi: 'कस्टम'
    },
    tabMinimap: {
        ru: 'Обзор холста', en: 'Canvas view', es: 'Vista del lienzo', pt: 'Vista da tela',
        de: 'Leinwandansicht', fr: 'Vue de la toile', th: 'มุมมองผืนผ้าใบ', ko: '캔버스 보기', zh: '画布视图', ja: 'キャンバスビュー', hi: 'कैनवस दृश्य'
    },
    tabTools: {
        ru: 'Инструменты', en: 'Tools', es: 'Herramientas', pt: 'Ferramentas',
        de: 'Werkzeuge', fr: 'Outils', th: 'เครื่องมือ', ko: '도구', zh: '工具', ja: 'ツール', hi: 'उपकरण'
    },
    btnResetWall: {
        ru: 'Очистить стену', en: 'Clear wall', es: 'Limpiar pared', pt: 'Limpar parede',
        de: 'Wand reinigen', fr: 'Effacer le mur', th: 'ล้างกำแพง', ko: '벽 초기화', zh: '清理墙面', ja: '壁を消去', hi: 'दीवार साफ़ करें'
    },
    btnResetPreset: {
        ru: 'Сбросить настройки', en: 'Reset settings', es: 'Restablecer ajustes', pt: 'Redefinir config',
        de: 'Einstellungen zurücksetzen', fr: 'Réinitialiser les paramètres', th: 'รีเซ็ตการตั้งค่า', ko: '설정 초기화', zh: '重置设置', ja: '設定をリセット', hi: 'सेटिंग्स रीसेट करें'
    },
    btnApply: {
        ru: 'Применить', en: 'Apply', es: 'Aplicar', pt: 'Aplicar',
        de: 'Anwenden', fr: 'Appliquer', th: 'นำไปใช้', ko: '적용', zh: '应用', ja: '適用', hi: 'लागू करें'
    },
    btnCancel: {
        ru: 'Отмена', en: 'Cancel', es: 'Cancelar', pt: 'Cancelar',
        de: 'Abbrechen', fr: 'Annuler', th: 'ยกเลิก', ko: '취소', zh: '取消', ja: 'キャンセル', hi: 'रद्द करें'
    },
    lblBgInput: {
        ru: 'Фон:', en: 'BG:', es: 'Fondo:', pt: 'Fundo:',
        de: 'Hintergrund:', fr: 'Fond:', th: 'พื้นหลัง:', ko: '배경:', zh: '背景:', ja: '背景:', hi: 'पृष्ठभूमि:'
    },
    lblToggleGrid: {
        ru: 'Метрическая сетка', en: 'Meter grid', es: 'Cuadrícula métrica', pt: 'Grade métrica',
        de: 'Gitter', fr: 'Grille', th: 'ตารางเมตร', ko: '미터 그리드', zh: '米字格', ja: 'メーターグリッド', hi: 'मीटर ग्रिड'
    },
    lblToggleMinimap: {
        ru: 'Миникарта', en: 'Minimap', es: 'Minimapa', pt: 'Minimapa',
        de: 'Minikarte', fr: 'Minicarte', th: 'แผนที่ขนาดเล็ก', ko: '미니맵', zh: '小地图', ja: 'ミニマップ', hi: 'छोटा नक्शा'
    },
    lblOnlyZoom: {
        ru: 'Только зум', en: 'Only zoom', es: 'Solo zoom', pt: 'Apenas zoom',
        de: 'Nur Zoom', fr: 'Zoom uniquement', th: 'ซูมเท่านั้น', ko: '줌만 보기', zh: '仅缩放', ja: 'ズームのみ', hi: 'केवल ज़ूम'
    },
    lblEnableGhost: {
        ru: 'Контрольный штрих', en: 'Control stroke', es: 'Trazo de control', pt: 'Traço de controle',
        de: 'Kontrollstrich', fr: 'Trait de contrôle', th: 'เส้นควบคุม', ko: '컨트롤 스트로크', zh: '对照笔划', ja: 'コントロールストローク', hi: 'नियнтенण स्ट्रोक'
    },
    lblZoom: {
        ru: 'Zoom  ', en: 'Zoom  ', es: 'Zoom  ', pt: 'Zoom  ',
        de: 'Zoom  ', fr: 'Zoom  ', th: 'ซูม  ', ko: '확대/축소  ', zh: '缩放  ', ja: 'ズーム  ', hi: 'ज़ूम'
    },
    btnHexColor: {
        ru: 'Выберите цвет', en: 'Select color', es: 'Seleccionar color', pt: 'Selecione a cor',
        de: 'Farbe wählen', fr: 'Sélectionner la couleur', th: 'เลือกสี', ko: '색상 선택', zh: '选择颜色', ja: '色を選択', hi: 'रंग चुनें'
    },
    btnSelectRoller: {
        ru: 'Выбрать валик', en: 'Select roller', es: 'Seleccionar rodillo', pt: 'Selecionar rolo',
        de: 'Rolle wählen', fr: 'Sélectionner le rouleau', th: 'เลือกลูกกลิ้ง', ko: '롤러 선택', zh: '选择滚筒', ja: 'ローラーを選択', hi: 'रोलर चुनें'
    },
    titleMinimap: {
        ru: 'Обзор холста', en: 'Canvas overview', es: 'Visión general', pt: 'Visão geral da tela',
        de: 'Leinwandübersicht', fr: 'Aperçu de la toile', th: 'ภาพรวมของผืนผ้าใบ', ko: '캔버스 개요', zh: '画布总览', ja: 'キャンバスの概要', hi: 'कैनवस अवलोकन'
    },
    titlePreset: {
        ru: 'Настроить пресет', en: 'Modify preset', es: 'Modificar preset', pt: 'Modificar predefinição',
        de: 'Preset anpassen', fr: 'Modifier le préréglage', th: 'ปรับแต่งพรีเซ็ต', ko: '프리셋 수정', zh: '修改预设', ja: 'プリセットを変更', hi: 'प्रीसेट संशोधित करें'
    },
    titleAddCan: {
        ru: 'Добавить новый баллон', en: 'Add new can', es: 'Añadir nuevo bote', pt: 'Adicionar nova lata',
        de: 'Neue Dose hinzufügen', fr: 'Ajouter une nouvelle bombe', th: 'เพิ่มกระป๋องใหม่', ko: '새 캔 추가', zh: '添加新喷漆罐', ja: '新しい缶を追加', hi: 'नया कैन जोड़ें'
    },
    tooltipEmptyCan: {
        ru: 'Добавить цвет в баллон', en: 'Add color to can', es: 'Añadir color al bote', pt: 'Adicionar cor à lata',
        de: 'Farbe zur Dose hinzufügen', fr: 'Ajouter de la couleur', th: 'เพิ่มสีในกระป๋อง', ko: '캔에 색상 추가', zh: '给喷漆添加颜色', ja: '缶に色を追加', hi: 'कैन में रंग डालें'
    },
    tooltipCanLeft: {
        ru: 'осталось', en: 'left', es: 'restante', pt: 'restante',
        de: 'übrig', fr: 'restant', th: 'เหลือ', ko: '남음', zh: '剩余', ja: '残り', hi: 'बचा है'
    },
    tooltipCanText: {
        ru: 'Баллон', en: 'Can', es: 'Bote', pt: 'Lata',
        de: 'Dose', fr: 'Bombe', th: 'กระป๋อง', ko: '캔', zh: '喷漆罐', ja: '缶', hi: 'कैन'
    },
    tooltipRollerText: {
        ru: 'Валик', en: 'Roller', es: 'Rodillo', pt: 'Rolo',
        de: 'Rolle', fr: 'Rouleau', th: 'ลูกกลิ้ง', ko: '롤러', zh: '滚筒', ja: 'ローラー', hi: 'रोलर'
    },
    presetNameBig: {
        ru: 'Крупный', en: 'Big', es: 'Grande', pt: 'Grande',
        de: 'Groß', fr: 'Grand', th: 'ใหญ่', ko: '대형', zh: '大', ja: '大', hi: 'बड़ा'
    },
    presetNameMid: {
        ru: 'Норм', en: 'Mid', es: 'Medio', pt: 'Médio',
        de: 'Mittel', fr: 'Moyen', th: 'กลาง', ko: '중형', zh: '中', ja: '中', hi: 'मध्यम'
    },
    presetNameSmall: {
        ru: 'Мелкий', en: 'Small', es: 'Pequeño', pt: 'Pequeno',
        de: 'Klein', fr: 'Petit', th: 'เล็ก', ko: '소형', zh: '小', ja: '小', hi: 'छोटा'
    },
    presetBigRoller: {
        ru: 'Большой валик 40см', en: 'Big roller 40cm', es: 'Rodillo grande 40cm', pt: 'Rolo grande 40cm',
        de: 'Große Rolle 40cm', fr: 'Grand rouleau 40cm', th: 'ลูกกลิ้งใหญ่ 40 ซม.', ko: '대형 롤러 40cm', zh: '大滚筒 40cm', ja: '大ローラー 40cm', hi: 'बड़ा रोलर 40 सेमी'
    },
    presetMidRoller: {
        ru: 'Средний валик 20см', en: 'Mid roller 20cm', es: 'Rodillo medio 20cm', pt: 'Rolo médio 20cm',
        de: 'Mittlere Rolle 20cm', fr: 'Rouleau moyen 20cm', th: 'ลูกกลิ้งกลาง 20 ซม.', ko: '중형 롤러 20cm', zh: '中滚筒 20cm', ja: '中ローラー 20cm', hi: 'मध्यम रोलर 20 सेमी'
    },
    presetSmallRoller: {
        ru: 'Маркер 5см', en: 'Marker 5cm', es: 'Marcador 5cm', pt: 'Marcador 5cm',
        de: 'Marker 5cm', fr: 'Marqueur 5cm', th: 'ปากกามาร์กเกอร์ 5 ซม.', ko: '마커 5cm', zh: '马克笔 5cm', ja: 'マーカー 5cm', hi: 'मार्कर 5 सेमी'
    },
    presetBigSpray: {
        ru: 'Большой кэп: 50 см до стены', en: 'Big cap: 50cm to wall', es: 'Tapón grande: 50cm a la pared', pt: 'Tampa grande: 50cm da parede',
        de: 'Große Cap: 50cm zur Wand', fr: 'Grand cap: 50cm du mur', th: 'หัวฉีดใหญ่: ห่างจากผนัง 50 ซม.', ko: '대형 캡: 벽에서 50cm', zh: '大喷头: 距墙50cm', ja: '大キャップ: 壁から50cm', hi: 'बड़ा कैप: दीवार से 50 सेमी'
    },
    presetMidSpray: {
        ru: 'Средний кэп: 25 см до стены', en: 'Medium cap: 25cm to wall', es: 'Tapón medio: 25cm a la pared', pt: 'Tampa média: 25cm da parede',
        de: 'Mittlere Cap: 25cm zur Wand', fr: 'Cap moyen: 25cm du mur', th: 'หัวฉีดกลาง: ห่างจากผนัง 25 ซม.', ko: '중형 캡: 벽에서 25cm', zh: '中等喷头: 距墙25cm', ja: '中キャップ: 壁から25cm', hi: 'मध्यम कैप: दीवार से 25 सेमी'
    },
    presetSmallSpray: {
        ru: 'Тэг-кэп: 10 см до стены', en: 'Tag cap: 10cm to wall', es: 'Tapón tag: 10cm a la pared', pt: 'Tampa tag: 10cm da parede',
        de: 'Tag-Cap: 10cm zur Wand', fr: 'Cap tag: 10cm du mur', th: 'หัวฉีดแท็ก: ห่างจากผนัง 10 ซม.', ko: '태그 캡: 벽에서 10cm', zh: '标签喷头: 距墙10cm', ja: 'タグキャップ: 壁から10cm', hi: 'टैग कैप: दीवार से 10 सेमी'
    },
    settingLineScale: {
        ru: 'Толщина линии', en: 'Line width', es: 'Grosor de línea', pt: 'Espessura da linha',
        de: 'Linienbreite', fr: 'Épaisseur de ligne', th: 'ความกว้างของเส้น', ko: '선 두께', zh: '线条粗细', ja: '線の太さ', hi: 'रेखा की चौड़ाई'
    },
    settingDensity: {
        ru: 'Плотность', en: 'Density', es: 'Densidad', pt: 'Densidade',
        de: 'Dichte', fr: 'Densité', th: 'ความหนาแน่น', ko: '밀도', zh: '密度', ja: '密度', hi: 'घनत्व'
    },
    settingRadius: {
        ru: 'Радиус распыления', en: 'Spray radius', es: 'Radio de rociado', pt: 'Raio de pulverização',
        de: 'Sprühradius', fr: 'Rayon de pulvérisation', th: 'รัศมีการพ่น', ko: '스프레이 반경', zh: '喷洒半径', ja: 'スプレー半径', hi: 'स्प्रे त्रिज्या'
    },
    settingSpeed: {
        ru: 'Скорость полета', en: 'Flow speed', es: 'Velocidad de flujo', pt: 'Velocidade de fluxo',
        de: 'Fluggeschwindigkeit', fr: 'Vitesse de flux', th: 'ความเร็วในการไหล', ko: '유속', zh: '流动速度', ja: '流速', hi: 'प्रवाह की गति'
    },
    settingDripChance: {
        ru: 'Шанс подтека', en: 'Drip chance', es: 'Probabilidad de goteo', pt: 'Chance de gotejamento',
        de: 'Tropfenwahrscheinlichkeit', fr: 'Chances de coulure', th: 'โอกาสเกิดหยดสี', ko: '흘러내림 확률', zh: '滴漏几率', ja: '液だれ確率', hi: 'टपकने की संभावना'
    },
    settingDripLength: {
        ru: 'Длина подтека', en: 'Drip length', es: 'Longitud de goteo', pt: 'Comprimento do gotejamento',
        de: 'Tropfenlänge', fr: 'Longueur de coulure', th: 'ความยาวหยดสี', ko: '흘러내림 길이', zh: '滴漏长度', ja: '液だれ長さ', hi: 'टपकने की लंबाई'
    },
    minimapTitleHint: {
        ru: 'Миникарта холста — кликни для навигации', en: 'Canvas minimap — click to navigate', es: 'Minimapa del lienzo — clic para navegar', pt: 'Minimapa da tela — clique para navegar',
        de: 'Leinwand Minikarte — klicken zur Navigation', fr: 'Minicarte — cliquez pour naviguer', th: 'แผนที่ขนาดเล็ก — คลิกเพื่อนําทาง', ko: '캔버스 미니맵 — 클릭하여 이동', zh: '画布小地图 — 点击导航', ja: 'ミニマップ — クリックして移動', hi: 'कैनवस मिनीमैप — नेविगेट करने के लिए क्लिक करें'
    },
    minimapTitleRO: {
        ru: 'Миникарта холста', en: 'Canvas minimap', es: 'Minimapa del lienzo', pt: 'Minimapa da tela',
        de: 'Leinwand Minikarte', fr: 'Minicarte de la toile', th: 'แผนที่ขนาดเล็ก', ko: '캔버스 미니맵', zh: '画布小地图', ja: 'ミニマップ', hi: 'कैनवस मिनीमैप'
    },
    indicatorDripsOn: {
        ru: 'Включены подтёки', en: 'Drips enabled', es: 'Goteos activados', pt: 'Gotejamentos ativados',
        de: 'Tropfen aktiviert', fr: 'Coulures activées', th: 'เปิดใช้งานหยดสี', ko: '흘러내림 활성화', zh: '滴漏功能已启用', ja: '液だれオン', hi: 'ड्रिप्स सक्षम'
    },
    lpEarlyAccess: {
        en: 'Early Access', ru: 'Ранний доступ', es: 'Acceso Anticipado', pt: 'Acesso Antecipado',
        de: 'Frühzeitiger Zugang', fr: 'Accès Anticipé', th: 'การเข้าถึงล่วงหน้า', ko: '얼리 액세스', zh: '抢先体验', ja: 'アーリーアクセス', hi: 'प्रारंभिक पहुँच'
    },
    lpTitle: {
        en: 'The Infinite Digital Graffiti Wall', ru: 'Бесконечная цифровая граффити стена', es: 'El Muro de Graffiti Digital Infinito', pt: 'A Parede de Graffiti Digital Infinita',
        de: 'Die unendliche digitale Graffiti-Wand', fr: 'Le Mur de Graffiti Numérique Infini', th: 'กำแพงกราฟฟิตีดิจิทัลที่ไร้ขอบเขต', ko: '무한한 디지털 그래피티 벽', zh: '无限的数字涂鸦墙', ja: '無限のデジタルグラフィティウォール', hi: 'अनंत डिजिटल ग्रैफिटी वॉल'
    },
    lpSubtitle: {
        en: 'A global platform connecting street artists and collectors. Experience our hyper-realistic spray engine, paint on a worldwide wall, and immortalize your street art.',
        ru: 'Глобальная платформа, объединяющая уличных художников. Испытай гиперреалистичный движок, рисуй на мировой стене и увековечь свое искусство.',
        es: 'Una plataforma global que conecta a artistas callejeros. Experimenta nuestro motor hiperrealista, pinta en un muro mundial y haz inmortal tu arte.',
        pt: 'Uma plataforma global conectando artistas de rua. Experimente nosso motor hiper-realista, pinte em um muro mundial e imortalize sua arte.',
        de: 'Eine globale Plattform für Straßenkünstler. Erlebe unseren hyperrealistischen Sprühmotor und verewige deine Kunst.',
        fr: 'Une plateforme mondiale pour artistes. Essayez notre moteur hyperréaliste et peignez sur un mur mondial.',
        th: 'แพลตฟอร์มระดับโลกสำหรับศิลปินแนวสตรีทอาร์ต สัมผัสกับเอนจิ้นสเปรย์เสมือนจริงและสร้างผลงานของคุณ',
        ko: '스트리트 아티스트를 연결하는 글로벌 플랫폼. 초현실적인 스프레이 엔진을 경험하고 작품을 영원히 남기세요.',
        zh: '连接街头艺术家和收藏家的全球平台。体验我们极其逼真的涂鸦引擎，在世界级涂鸦墙上留下你的作品。',
        ja: 'ストリートアーティストをつなぐグローバルプラットフォーム。超リアルなスプレーエンジンを体験しよう。',
        hi: 'स्ट्रीट आर्टिस्ट्स को जोड़ने वाला एक वैश्विक मंच। हमारे अति-यथार्थवादी स्प्रे इंजन का अनुभव करें और अपनी कला को अमर बनाएं।'
    },
    lpTryEngine: {
        en: 'Leave your mark', ru: 'Оставь свой след', es: 'Deja tu huella', pt: 'Deixe sua marca',
        de: 'Setz dein Zeichen', fr: 'Laisse ta trace', th: 'ฝากผลงานของคุณ', ko: '흔적을 남기세요', zh: '留下印记', ja: '痕跡を残す', hi: 'अपनी छाप छोड़ें'
    },
    lpJoinTelegram: {
        en: 'Join Telegram', ru: 'Наш Telegram', es: 'Unirse a Telegram', pt: 'Entrar no Telegram',
        de: 'Telegram beitreten', fr: 'Rejoindre Telegram', th: 'เข้าร่วม Telegram', ko: '텔레그램 참여', zh: '加入电报群', ja: '電報 に参加', hi: 'टेलीग्राम से जुड़ें'
    },
    lpVisionTitle: {
        en: 'Art Without Boundaries', ru: 'Искусство без границ', es: 'Arte Sin Fronteras', pt: 'Arte Sem Fronteiras',
        de: 'Kunst ohne Grenzen', fr: 'Art Sans Frontières', th: 'ศิลปะไร้พรมแดน', ko: '경계 없는 예술', zh: '无界艺术', ja: '境界なきアート', hi: 'सीमाओं के बिना कला'
    },
    lpVisionText: {
        en: 'Graffiti has always been restricted by physical space, geography, and permanence. Street Wall redefines the culture by providing a single, massive, infinite virtual wall. Whether you are bombing from the streets of New York, Berlin, São Paulo, or Tokyo, your pieces live forever on a worldwide canvas alongside the greatest global talent.',
        ru: 'Граффити всегда было ограничено физическим пространством и временем. Street Wall меняет культуру, предоставляя единую, бесконечную виртуальную стену. Неважно, где ты — в Нью-Йорке, Берлине, Сан-Паулу или Токио, твои работы будут жить вечно на мировом холсте.',
        es: 'El graffiti siempre ha estado restringido por el espacio físico y el tiempo. Street Wall redefine la cultura proporcionando un muro virtual infinito.',
        pt: 'O graffiti sempre foi restrito pelo espaço físico. Street Wall redefine a cultura fornecendo um muro virtual infinito.',
        de: 'Graffiti war immer durch Raum und Zeit beschränkt. Street Wall verändert diese Kultur mit einer unendlichen virtuellen Wand.',
        fr: 'Le graffiti a toujours été limité par l\'espace. Street Wall redéfinit la culture en offrant un mur virtuel infini.',
        th: 'กราฟฟิตีมักถูกจำกัดโดยพื้นที่ Street Wall นิยามวัฒนธรรมใหม่ด้วยกำแพงเสมือนจริงที่ไม่มีที่สิ้นสุด',
        ko: '그래피티는 항상 물리적 공간의 제약을 받았습니다. 스트리트 월은 무한한 가상 벽을 제공하여 문화를 재정의합니다.',
        zh: '涂鸦在现实世界受限于物理空间。Street Wall 通过提供绝对无限的虚拟涂鸦墙来重新定义这种文化。不论身在何处，你的作品都将永存。',
        ja: 'グラフィティは常に物理的な制限を受けてきました。ストリートウォールは広大な仮想空間でその文化を再定義します。',
        hi: 'ग्रैफिटी हमेशा भौतिक स्थान से सीमित रही है। स्ट्रीट वॉल एक अनंत आभासी दीवार प्रदान करके इस संस्कृति को फिर से परिभाषित करता है।'
    },
    lpFeature1Title: {
        en: 'Hyper-Realistic Physics', ru: 'Гиперреалистичная физика', es: 'Física Hiperrealista', pt: 'Física Hiper-realista',
        de: 'Hyperrealistische Physik', fr: 'Physique Hyperréaliste', th: 'ระบบฟิสิกส์เสมือนจริง', ko: '초현실적 물리 엔진', zh: '超写实物理特性', ja: '超リアルな物理法則', hi: 'अति-यथार्थवादी भौतिकी'
    },
    lpFeature1Text: {
        en: 'Our proprietary spray engine simulates paint flow, drips, can pressure, and custom nozzles (caps). Transition between fat caps for fills and skinny caps for outlines seamlessly.',
        ru: 'Наш движок симулирует потоки краски, подтеки, давление баллона и кастомные кэпы. Идеальный переход между фэт-кэпами для заливки и скинни-кэпами для контуров.',
        es: 'Nuestro motor simula el flujo de pintura, goteos, presión de la lata y boquillas. Transición perfecta entre fat caps para rellenos y skinny caps para contornos.',
        pt: 'Nosso motor simula o fluxo de tinta, gotejamentos, pressão da lata e bicos. Transição perfeita entre fat caps para preenchimentos e skinny caps para contornos.',
        de: 'Unser Sprühmotor simuliert Farbfluss, Druckgefüge und Tropfen. Ein nahtloser Übergang zwischen verschiedenen Kappen (Caps) ist möglich.',
        fr: 'Notre moteur simule le flux de peinture, la pression et les gouttes. Transition parfaite entre différents embouts.',
        th: 'ระบบฉีดสเปรย์จำลองการหยดของสีและแรงดัน ทำให้การวาดเขียนเป็นไปอย่างราบรื่น',
        ko: '자체 개발한 엔진은 페인트 흐름, 압력, 캡의 종류까지 완벽하게 시뮬레이션합니다.',
        zh: '我们独创的涂鸦引擎模拟真实的喷漆流速、滴漏、气压和特制喷头。在填充与勾线之间无缝切换。',
        ja: '独自のエンジンがスプレーの圧力、液だれ、ノズルを精巧にシミュレートします。',
        hi: 'हमारा स्प्रे इंजन पेंट प्रवाह, दबाव और कैप को अनुकरण करता है। भरने से रूपरेखा तक निर्बाध रूप से संक्रमण।'
    },
    lpFeature2Title: {
        en: 'Global Culture', ru: 'Глобальная Культура', es: 'Cultura Global', pt: 'Cultura Global',
        de: 'Globale Kultur', fr: 'Culture Mondiale', th: 'วัฒนธรรมระดับโลก', ko: '글로벌 문화', zh: '全球文化', ja: 'グローバルカルチャー', hi: 'वैश्विक संस्कृति'
    },
    lpFeature2Text: {
        en: 'Collaborate and clash with writers from every continent. See styles evolve as European wildstyles mix with Latin American pixação and classic US bubble letters.',
        ru: 'Коллаборируйте с райтерами со всех континентов. Смотрите, как европейский уайлдстайл смешивается с латиноамериканским пишасау и классическими баблами из США.',
        es: 'Colabora con escritores de todos los continentes. Mira cómo evolucionan los estilos mientras el wildstyle europeo se mezcla con pichação latino.',
        pt: 'Colabore com escritores de todos os continentes. Veja como os estilos evoluem enquanto o wildstyle europeu se mistura com a pixação latino-americana.',
        de: 'Arbeite mit Künstlern aus allen Kontinenten zusammen und sehe, wie sich verschiedene Graffiti-Kulturen verbinden.',
        fr: 'Collaborez avec des artistes de tous les continents et observez l\'évolution des styles mondiaux.',
        th: 'ร่วมสร้างสรรค์ผลงานกับศิลปินจากทุกทวีปทั่วโลกและดูการผสมผสานของหลากสไตล์',
        ko: '전 세계 아티스트들과 협업하고 충돌하며 진화하는 그래피티 스타일을 확인하세요.',
        zh: '与各大洲的涂鸦写手合作与碰撞。看着美式泡泡字与拉美字体在墙上交织演变。',
        ja: 'あらゆる国のアートコミュニティと協力し、世界のスタイルが融合するのを目撃してください。',
        hi: 'हर महाद्वीप के कलाकारों के साथ सहयोग करें और देखें कि शैली कैसे विकसित होती है।'
    },
    lpFeature3Title: {
        en: 'Monetize & Collect', ru: 'Монетизируй и Коллекционируй', es: 'Monetiza y Colecciona', pt: 'Monetize e Colecione',
        de: 'Monetarisieren', fr: 'Monétisez & Collectionnez', th: 'สะสมและสร้างรายได้', ko: '수익화 및 수집', zh: '收益变现与收藏', ja: '収益化とコレクション', hi: 'कमाई और संग्रह'
    },
    lpFeature3Text: {
        en: 'Turn your pieces into verifiable digital assets. Galleries and collectors can support artists directly by purchasing historical panels and tags from the infinite wall.',
        ru: 'Превращайте свои куски в цифровые активы. Галереи и коллекционеры могут напрямую поддерживать художников, покупая панели с бесконечной стены.',
        es: 'Convierte tus piezas en activos digitales. Galerías y coleccionistas pueden apoyar directamente a los artistas comprando paneles.',
        pt: 'Transforme suas peças em ativos digitais. Galerias e colecionadores podem apoiar diretamente os artistas comprando painéis na parede.',
        de: 'Verwandle deine Werke in digitale Assets, die von Sammlern direkt unterstützt werden können.',
        fr: 'Transformez vos œuvres en actifs numériques et permettez aux collectionneurs de vous soutenir directement.',
        th: 'เปลี่ยนผลงานของคุณให้กลายเป็นสินทรัพย์ดิจิทัลที่นักสะสมสามารถเข้าถึงได้',
        ko: '작품을 디지털 자산으로 변환하세요. 수집가들은 무한의 벽에서 패널을 구매해 당신을 직접 후원할 수 있습니다.',
        zh: '将你的涂鸦转化为具有价值的数字资产。通过出售画板给画廊或收藏家并获得支持。',
        ja: '作品をデジタル資産に変えましょう。ギャラリーやコレクターは直接あなたのアートを購入して支援できます。',
        hi: 'अपने काम को डिजिटल संपत्ति में बदलें। संग्राहक सीधे कलाकारों का समर्थन कर सकते हैं।'
    },
    lpGalleryTitle: {
        en: 'The Global Gallery', ru: 'Глобальная Галерея', es: 'La Galería Global', pt: 'A Galeria Global',
        de: 'Die Globale Galerie', fr: 'La Galerie Mondiale', th: 'แกลลอรีระดับโลก', ko: '글로벌 갤러리', zh: '全景画廊', ja: 'グローバルギャラリー', hi: 'वैश्विक गैलरी'
    },
    lpGalleryText: {
        en: 'Own a piece of digital street art history. The infinite canvas is divided into unique panels that collectors can acquire, supporting the artists who painted them.',
        ru: 'Станьте владельцем частицы цифровой стрит-арт истории. Бесконечный холст разделен на панели, которые могут приобрести коллекционеры.',
        es: 'Posee un pedazo de historia. El lienzo infinito se divide en paneles únicos que los coleccionistas pueden adquirir.',
        pt: 'Possua um pedaço da história. A tela infinita é dividida em painéis únicos que colecionadores podem adquirir.',
        de: 'Besitze ein Stück digitale Geschichte. Die unendliche Leinwand besteht aus Paneelen für Sammler.',
        fr: 'Possédez un morceau d\'histoire. La toile infinie est divisée en panneaux pour les collectionneurs.',
        th: 'เป็นเจ้าของประวัติศาสตร์ศิลปะบนกำแพง ผืนผ้าใบถูกแบ่งออกเป็นส่วนๆ เพื่อให้คุณสะสม',
        ko: '디지털 스트리트 아트 역사의 한 조각을 소유하세요. 캔버스는 독특한 패널로 나뉘며 누구든 구매 가능합니다.',
        zh: '拥有数字街头艺术历史的一部分。无限画卷被划分为了独特的收藏板块。',
        ja: 'デジタルストリートアートの歴史を手に入れましょう。無限のキャンバスはコレクターのためのパネルに分かれています。',
        hi: 'डिजिटल स्ट्रीट आर्ट के इतिहास का एक टुकड़ा अपनाएं। संग्राहक पैनल खरीद सकते हैं।'
    },
    lpGalleryNFT: {
        en: 'Selling artwork through NFTs is the future we are striving for. We aim to empower artists to fully own and monetize their digital presence.',
        ru: 'Продажа изображений через NFT — это будущее, к которому мы стремимся. Наша цель — дать художникам возможность полноценно владеть и монетизировать свое цифровое присутствие.',
        es: 'La venta de obras a través de NFTs es el futuro hacia el que nos dirigimos. Nuestro objetivo es empoderar a los artistas para que posean y moneticen su presencia digital.',
        pt: 'A venda de obras através de NFTs é o futuro que almejamos. Nosso objetivo é capacitar os artistas para possuir e monetizar totalmente sua presença digital.',
        de: 'Der Verkauf von Kunstwerken über NFTs ist die Zukunft, für die wir eintreten. Unser Ziel ist es, Künstler zu stärken.',
        fr: 'La vente d\'œuvres d\'art via NFT est notre ambition. Nous voulons aider les artistes à monétiser leur talent.',
        th: 'การขายงานศิลปะผ่าน NFT คืออนาคตที่เรามุ่งหวัง เพื่อช่วยให้ศิลปินสามารถจัดการรายได้ของตัวเอง',
        ko: 'NFT를 통한 갤러리 판매가 우리의 비전입니다. 아티스트들이 자신의 디지털 존재를 완전히 소유하고 수익화할 수 있게 합니다.',
        zh: '通过 NFT 出售作品是我们追求的未来。我们的目标是赋能艺术家，完全掌控他们数字资产的价值。',
        ja: 'NFTによるアート販売が私たちの目指す未来です。アーティストが自らのプレゼンスを完全にコントロールし収益化できるよう支援します。',
        hi: 'NFT के माध्यम से कलाकृतियां बेचना वह भविष्य है जिसके लिए हम प्रयासरत हैं।'
    },
    lpGalleryFreedom: {
        en: 'Globally, we envision this virtual board as a space for collective creativity, completely free of political and administrative constraints.',
        ru: 'Глобально мы хотим, чтобы виртуальная доска стала местом коллективного творчества абсолютно без политической и административной конъюнктуры.',
        es: 'A nivel global, queremos que esta pizarra virtual sea un espacio de creatividad colectiva, libre de agendas políticas y administrativas.',
        pt: 'Globalmente, queremos que este quadro virtual se torne um espaço para criatividade coletiva, livre de interferências políticas e administrativas.',
        de: 'Wir sehen diese virtuelle Tafel als einen von politischer und administrativer Kontrolle freien Ort der globalen Kreativität.',
        fr: 'Nous envisageons cet espace comme un lieu de créativité libre, sans aucune contrainte politique.',
        th: 'เรามองว่าบอร์ดเสมือนจริงนี้คือพื้นที่ปลอดข้อจำกัดทางการเมืองและสังคม เพื่อความคิดสร้างสรรค์ที่แท้จริง',
        ko: '글로벌한 이 가상 보드가 어떠한 정치적, 행정적 제약도 없는 완벽하게 자유로운 창작의 장이 되길 바랍니다.',
        zh: '在全球范围内，我们坚信这块虚拟黑板将成为集体创意的乌托邦，完全不受政治与体制的局限。',
        ja: 'この仮想ボードが、政治的・管理的制約から完全に解放された集団的な創造性の場になると信じています。',
        hi: 'विश्व स्तर पर, हम इस आभासी बोर्ड को रचनात्मकता के लिए एक स्थान के रूप में देखते हैं, जो बाधाओं से मुक्त है।'
    },
    lpFooterTitle: {
        en: 'Ready to leave your mark?', ru: 'Готов оставить свой след?', es: '¿Listo para dejar tu marca?', pt: 'Pronto para deixar sua marca?',
        de: 'Bereit, dein Zeichen zu setzen?', fr: 'Prêt à laisser votre marque ?', th: 'พร้อมจะทิ้งผลงานของคุณ илиยัง?', ko: '당신의 흔적을 남길 준비가 되셨나요?', zh: '准备好留下你的印记了吗？', ja: '準備はいいですか？', hi: 'अपनी छाप छोड़ने के लिए तैयार हैं?'
    },
    lpFooterBtn: {
        en: 'Try the Sandbox', ru: 'Попробовать песочницу', es: 'Probar el Sandbox', pt: 'Testar o Sandbox',
        de: 'Sandbox ausprobieren', fr: 'Essayer le Sandbox', th: 'ลองเล่นในแซндบ็อกซ์', ko: '샌드박스 체험하기', zh: '尝试沙盒模式', ja: 'サンドボックスを試す', hi: 'सैंडबॉक्स आज़माएं'
    },
    lpSandboxTip: {
        en: 'You can also draw on a private sandbox wall available only to you. It offers more features like clearing the canvas and starting fresh.',
        ru: 'Также ты можешь порисовать на приватной стене-песочнице, доступной только тебе. Здесь больше возможностей: можно очищать холст и начинать заново.',
        es: 'También puedes dibujar en un muro sandbox privado solo para ti. Ofrece más funciones como limpiar el lienzo y empezar de cero.',
        pt: 'Você também pode desenhar em um mural sandbox privado só para você. Ele oferece mais recursos como limpar a tela e começar do zero.',
        de: 'Du kannst auch an einer privaten Sandbox-Wand zeichnen. Es bietet mehr Funktionen wie das Reinigen der Leinwand.',
        fr: 'Vous pouvez aussi dessiner sur un mur sandbox privé. Il offre plus de fonctionnalités comme le nettoyage de la toile.',
        th: 'คุณยังสามารถวาดบนแซนด์บ็อกซ์ส่วนตัวที่รวมฟีเจอร์ต่างๆ เช่น การล้างผืนผ้าใบ',
        ko: '당신만 사용할 수 있는 개인용 샌드박스에서도 그림을 그릴 수 있습니다. 캔버스 초기화 등 더 많은 기능을 제공합니다.',
        zh: '你也可以在仅供你使用的私密沙盒墙上创作。这里功能更全，比如可以清空画布重新开始。',
        ja: 'あなた専用のプライベート・サンドボックスでも描画できます。キャンバスのクリアなど、より多くの機能を利用できます。',
        hi: 'आप केवल अपने लिए उपलब्ध एक निजी सैंडबॉक्स दीवार पर भी चित्र बना सकते हैं।'
    },
    seoTitle: {
        en: 'Street Wall | The Infinite Digital Graffiti Canvas',
        ru: 'Street Wall | Бесконечный цифровой холст для граффити',
        es: 'Street Wall | El lienzo de grafiti digital infinito',
        pt: 'Street Wall | A tela infinita de grafite digital',
        de: 'Street Wall | Die unendliche digitale Graffiti-Leinwand',
        fr: 'Street Wall | La toile de graffiti numérique infinie',
        th: 'Street Wall | ผืนผ้าใบกราฟฟิตีดิจิทัลที่ไร้ขอบเขต',
        ko: 'Street Wall | 무한한 디지털 그래피티 캔버스',
        zh: 'Street Wall | 无限数字涂鸦墙',
        ja: 'Street Wall | 無限のデジタルグラフィティキャンバス',
        hi: 'Street Wall | अनंत डिजिटल ग्रैफिटी कैनवास'
    },
    seoDescription: {
        en: 'Create hyper-realistic graffiti, share your vision, and monetize your street art on an infinite digital canvas.',
        ru: 'Создавайте гиперреалистичные граффити, делитесь своим видением и монетизируйте стрит-арт на бесконечном цифровом холсте.',
        es: 'Crea grafite hiperrealista, comparte tu visión y monetiza tu arte callejero en un lienzo digital infinito.',
        pt: 'Crie grafites hiper-realistas, compartilhe sua visão e monetize sua arte de rua em uma tela digital infinita.',
        de: 'Erstellen Sie hyperrealistische Graffiti, teilen Sie Ihre Vision und monetarisieren Sie Ihre Street Art auf einer unendlichen digitalen Leinwand.',
        fr: 'Créez des graffitis hyperréalistes, partagez votre vision et monétisez votre art de rue sur une toile numérique infinie.',
        th: 'สร้างกราฟฟิตีที่สมจริงเกินจริง แบ่งปันวิสัยทัศน์ของคุณ และสร้างรายได้จากสตรีทอาร์ตบนผืนผ้าใบดิจิทัลที่ไม่มีที่สิ้นสุด',
        ko: '초현실적인 그래피티를 만들고, 비전을 공유하며, 무한한 디지털 캔버스에서 스트리트 아트를 수익화하세요.',
        zh: '在无限的数字画布上创作极其逼真的涂鸦，分享您的愿景并实现街头艺术变现。',
        ja: '無限のデジタルキャンバスで、超リアルなグラフィティを作成し、ビジョンを共有し、ストリートアートを収益化しましょう。',
        hi: 'अति-यथार्थवादी ग्रैफिटी बनाएं, अपनी दृष्टि साझा करें, और एक अनंत डिजिटल कैनवास पर अपनी सड़क कला का मुद्रीकरण करें।'
    },
    previewModeLabel: {
        ru: 'Примерка', en: 'Test drive', es: 'Prueba', pt: 'Teste',
        de: 'Vorschau', fr: 'Essai', th: 'ทดลอง', ko: '시험', zh: '试色', ja: 'テスト', hi: 'परीक्षण'
    },
    btnKeepColor: {
        ru: 'Оставить', en: 'Keep', es: 'Conservar', pt: 'Manter',
        de: 'Behalten', fr: 'Garder', th: 'เก็บไว้', ko: '유지', zh: '保留', ja: '保存', hi: 'रखें'
    },
    previewModeCustomLabel: {
        ru: 'Примерка своего цвета', en: 'Your custom color test drive', es: 'Prueba de tu color personalizado', pt: 'Teste da sua cor personalizada',
        de: 'Test deiner eigenen Farbe', fr: 'Essai de votre couleur', th: 'ทดลองสีที่กำหนดเอง', ko: '커스텀 색상 시험', zh: '自定义颜色试色', ja: 'カスタムカラーのテスト', hi: 'कस्टम रंग का परीक्षण'
    },
    previewModeCapLabel: {
        ru: 'Тест-драйв', en: 'Cap test drive', es: 'Prueba de difusor', pt: 'Teste de bico',
        de: 'Cap-Test', fr: 'Essai de cap', th: 'ทดลองหัวสเปรย์', ko: '캡 시험', zh: '喷嘴试用', ja: 'キャップテスト', hi: 'कैप परीक्षण'
    },
    customColorHeaderColor: {
        ru: 'Цвет', en: 'Color', es: 'Color', pt: 'Cor',
        de: 'Farbe', fr: 'Couleur', th: 'สี', ko: '색상', zh: '颜色', ja: '色', hi: 'रंग'
    },
    customColorHeaderHex: {
        ru: 'HEX Код', en: 'HEX Code', es: 'Código HEX', pt: 'Código HEX',
        de: 'HEX-Code', fr: 'Code HEX', th: 'รหัส HEX', ko: 'HEX 코드', zh: '十六进制代码', ja: 'HEXコード', hi: 'हेक्स कोड'
    },
    customColorHeaderName: {
        ru: 'Название (подсказка)', en: 'Name (hint)', es: 'Nombre (pista)', pt: 'Nome (dica)',
        de: 'Name (Hinweis)', fr: 'Nom (indice)', th: 'ชื่อ (คำใบ้)', ko: '이름 (힌트)', zh: '名称（提示）', ja: '名前（ヒント）', hi: 'नाम (संकेत)'
    },
    customColorPlaceholderHex: {
        ru: '#HEX', en: '#HEX', es: '#HEX', pt: '#HEX',
        de: '#HEX', fr: '#HEX', th: '#HEX', ko: '#HEX', zh: '#HEX', ja: '#HEX', hi: '#HEX'
    },
    customColorPlaceholderName: {
        ru: 'Название цвета', en: 'Color name', es: 'Nombre del color', pt: 'Nome da cor',
        de: 'Farbname', fr: 'Nom de la couleur', th: 'ชื่อสี', ko: '색상 이름', zh: '颜色名称', ja: '色名', hi: 'रंग का नाम'
    },
    customColorClearRowTitle: {
        ru: 'Очистить строку', en: 'Clear row', es: 'Limpiar fila', pt: 'Limpar linha',
        de: 'Zeile löschen', fr: 'Effacer la ligne', th: 'ล้างแถว', ko: '행 지우기', zh: '清除行', ja: '行をクリア', hi: 'पंक्ति साफ़ करें'
    },
    customColorAddMore: {
        ru: '+ Добавить еще', en: '+ Add more', es: '+ Añadir más', pt: '+ Adicionar mais',
        de: '+ Mehr hinzufügen', fr: '+ Ajouter plus', th: '+ เพิ่มอีก', ko: '+ 더 추가', zh: '+ 添加更多', ja: '+ さらに追加', hi: '+ और जोड़ें'
    },
    lpHeaderLanguage: {
        ru: 'Язык', en: 'Language', es: 'Idioma', pt: 'Idioma',
        de: 'Sprache', fr: 'Langue', th: 'ภาษา', ko: '언어', zh: '语言', ja: '言語', hi: 'भाषा'
    },
    lpHeaderTheme: {
        ru: 'Тема', en: 'Theme', es: 'Tema', pt: 'Tema',
        de: 'Thema', fr: 'Thème', th: 'ธีม', ko: '테마', zh: '主题', ja: 'テーマ', hi: 'थीम'
    },
    lpHeaderStyle: {
        ru: 'Стиль', en: 'Style', es: 'Estilo', pt: 'Estilo',
        de: 'Stil', fr: 'Style', th: 'สไตล์', ko: '스타일', zh: '样式', ja: 'スタイル', hi: 'शैली'
    },
    themeSystem: {
        ru: 'Системная', en: 'System', es: 'Sistema', pt: 'Sistema',
        de: 'System', fr: 'Système', th: 'ระบบ', ko: '시스템', zh: '系统', ja: 'システム', hi: 'प्रणाली'
    },
    themeDark: {
        ru: 'Темная', en: 'Dark', es: 'Oscuro', pt: 'Escuro',
        de: 'Dunkel', fr: 'Sombre', th: 'มืด', ko: '다크', zh: '深色', ja: 'ダーク', hi: 'अंधेरा'
    },
    themeLight: {
        ru: 'Светлая', en: 'Light', es: 'Claro', pt: 'Claro',
        de: 'Hell', fr: 'Clair', th: 'สว่าง', ko: '라이트', zh: '浅色', ja: 'ライト', hi: 'रोशनी'
    },
    footerBackTitle: {
        ru: 'Вернуться на главную', en: 'Back to Landing', es: 'Volver al inicio', pt: 'Voltar ao início',
        de: 'Zurück zur Startseite', fr: 'Retour à l\'accueil', th: 'กลับสู่หน้าหลัก', ko: '메인으로 돌아가기', zh: '返回首页', ja: 'トップページへ戻る', hi: 'मुख्य पृष्ठ पर वापस'
    },
    footerVersionTitle: {
        ru: 'История обновлений', en: 'Update history', es: 'Historial de actualizaciones', pt: 'Histórico de atualizações',
        de: 'Update-Verlauf', fr: 'Historique des mises à jour', th: 'ประวัติการอัปเดต', ko: '업데이트 기록', zh: '更新历史', ja: '更新履歴', hi: 'अपडेट इतिहास'
    },
    footerCommunity: {
        ru: 'комьюнити', en: 'community', es: 'comunidad', pt: 'comunidade',
        de: 'community', fr: 'communauté', th: 'ชุมชน', ko: '커뮤니티', zh: '社区', ja: 'コミュニティ', hi: 'कम्युनिटी'
    },
    footerLanguageTitle: {
        ru: 'Выбрать язык', en: 'Select Language', es: 'Seleccionar idioma', pt: 'Selecionar idioma',
        de: 'Sprache wählen', fr: 'Choisir la langue', th: 'เลือกภาษา', ko: '언어 선택', zh: '选择语言', ja: '言語を選択', hi: 'भाषा चुनें'
    },
    footerThemeTitle: {
        ru: 'Выбрать тему', en: 'Select Theme', es: 'Seleccionar tema', pt: 'Selecionar tema',
        de: 'Thema wählen', fr: 'Choisir le thème', th: 'เลือกธีม', ko: '테마 선택', zh: '选择主题', ja: 'テーマを選択', hi: 'थीम चुनें'
    },
    footerViewsTitle: {
        ru: 'Просмотры', en: 'Total Views', es: 'Vistas totales', pt: 'Visualizações totais',
        de: 'Gesamtansichten', fr: 'Nombre de vues', th: 'ยอดการเข้าชมทั้งหมด', ko: '총 조회수', zh: '总浏览量', ja: '総表示数', hi: 'कुल दृश्य'
    },
    footerAbout: {
        ru: 'о проекте', en: 'about', es: 'acerca de', pt: 'sobre',
        de: 'über', fr: 'à propos', th: 'เกี่ยวกับ', ko: '소개', zh: '关于', ja: '概要', hi: 'के बारे में'
    },
    loading: {
        ru: 'Загрузка...', en: 'Loading...', es: 'Cargando...', pt: 'Carregando...',
        de: 'Wird geladen...', fr: 'Chargement...', th: 'กําลังโหลด...', ko: '로딩 중...', zh: '加载中...', ja: '読み込み中...', hi: 'लोloading...'
    },
    presetEnabled: {
        ru: 'Включен пресет', en: 'Preset enabled', es: 'Preset activado', pt: 'Predefinição ativada',
        de: 'Preset aktiviert', fr: 'Préréglage activé', th: 'เปิดใช้งานพรีเซ็ต', ko: '프리셋 활성화됨', zh: '预设已启用', ja: 'プリセット有効', hi: 'प्रीसेट सक्षम'
    },
    alertEmptyCan: {
        ru: 'Краска закончилась в баллоне', en: 'Paint finished in can', es: 'Pintura terminada en el bote', pt: 'Tinta acabou na lata',
        de: 'Farbe in der Dose leer', fr: 'Peinture terminée dans la bombe', th: 'สี в กระป๋องหมดแล้ว', ko: '캔의 페인트가 다 떨어졌습니다', zh: '喷漆罐已空', ja: '缶の塗料がなくなりました', hi: 'कैन में पेंट खत्म हो गया है'
    },
    footerHotkeysTitle: {
        ru: 'хоткеи', en: 'hotkeys', es: 'atajos', pt: 'teclas de atalho',
        de: 'tastenkombinationen', fr: 'raccourcis', th: 'คีย์ลัด', ko: '단축키', zh: '快捷键', ja: 'ショートカットキー', hi: 'हॉटकीज़'
    },
    hotkeyTheme: {
        ru: 'Переключить тему (Светлая/Темная)', en: 'Toggle Theme (Light/Dark)', es: 'Cambiar tema (Laro/Oscuro)', pt: 'Alternar tema (Claro/Escuro)',
        de: 'Thema wechseln (Hell/Dunkel)', fr: 'Changer de thème (Clair/Sombre)', th: 'สลับธีม (สว่าง/มืด)', ko: '테마 전환 (밝게/어둡게)', zh: '切换主题（明亮/黑暗）', ja: 'テーマ切り替え（ライト/ダーク）', hi: 'थीम बदलें (हल्का/गहरा)'
    },
    hotkeyZoom: {
        ru: 'Показать/скрыть метрическую сетку', en: 'Show/hide metric grid', es: 'Mostrar/ocultar cuadrícula', pt: 'Mostrar/ocultar grade métrica',
        de: 'Gitter ein-/ausblenden', fr: 'Afficher/masquer la grille', th: 'แสดง/ซ่อนตารางเมตร', ko: '그리드 표시/숨기기', zh: '显示/隐藏网格', ja: 'グリッドの表示/非表示', hi: 'ग्रिड दिखाएं/छिपाएं'
    },
    hotkeyPresetBig: {
        ru: 'Пресет Big / Переключить Flat режим', en: 'Preset Big / Toggle Flat mode', es: 'Preset Big / Alternar modo Flat', pt: 'Predefinição Grande / Alternar modo Flat',
        de: 'Preset Big / Flat-Modus umschalten', fr: 'Préréglage Big / Basculer en mode Flat', th: 'พรีเซ็ต Big / สลับโหมด Flat', ko: '프리셋 크게 / 플랫 모드 전환', zh: '大预设 / 切换平面模式', ja: '大型プリセット / フラットモード切り替え', hi: 'बड़ा प्रीसेट / फ्लैट मोड टॉगल करें'
    },
    hotkeyPresetMid: {
        ru: 'Пресет Mid / Переключить Flat режим', en: 'Preset Mid / Toggle Flat mode', es: 'Preset Mid / Alternar modo Flat', pt: 'Predefinição Média / Alternar modo Flat',
        de: 'Preset Mid / Flat-Modus umschalten', fr: 'Préréglage Mid / Basculer en mode Flat', th: 'พรีเซ็ต Mid / สลับโหมด Flat', ko: '프리셋 중간 / 플랫 모드 전환', zh: '中预设 / 切换平面模式', ja: '中型プリセット / フラットモード切り替え', hi: 'मध्यम प्रीसेट / फ्लैट मोड टॉगल करें'
    },
    hotkeyPresetSmall: {
        ru: 'Пресет Small / Переключить Flat режим', en: 'Preset Small / Toggle Flat mode', es: 'Preset Small / Alternar modo Flat', pt: 'Predefinição Pequena / Alternar modo Flat',
        de: 'Preset Small / Flat-Modus umschalten', fr: 'Préréglage Small / Basculer en mode Flat', th: 'พรีเซ็ต Small / สลับโหมด Flat', ko: '프리셋 작게 / 플랫 모드 전환', zh: '小预设 / 切换平面模式', ja: '小型プリセット / フラットモード切り替え', hi: 'छोटा प्रीसेट / फ्लैट मोड टॉगल करें'
    },
    hotkeyClear: {
        ru: 'Очистить стену', en: 'Clear wall', es: 'Limpiar pared', pt: 'Limpar parede',
        de: 'Wand löschen', fr: 'Effacer le mur', th: 'ล้างผนัง', ko: '벽 지우기', zh: '清除墙壁', ja: '壁をクリア', hi: 'दीवार साफ़ करें'
    },
    hotkeyFlashlight: {
        ru: 'Фонарик Вкл/Выкл (клавиша L)', en: 'Flashlight On/Off (L Key)', es: 'Linterna On/Off (Tecla L)', pt: 'Lanterna On/Off (Tecla L)',
        de: 'Taschenlampe An/Aus (Taste L)', fr: 'Lampe torche On/Off (Touche L)', ja: '懐中電灯 オン/オフ (Lキー)'
    },
    modalClearTitle: {
        ru: 'Очистить стену?', en: 'Clear Wall?', es: '¿Limpiar pared?', pt: 'Limpar parede?',
        de: 'Wand löschen?', fr: 'Effacer le mur ?', th: 'ล้างผนัง?', ko: '벽을 지우시겠습니까?', zh: '清除墙壁？', ja: '壁をクリアしますか？', hi: 'दीवार साफ़ करें?'
    },
    modalClearMessage: {
        ru: 'Вы уверены, что хотите полностью очистить стену?',
        en: 'Are you sure you want to completely clear the wall?',
        es: '¿Estás seguro de que quieres limpiar completamente la pared?',
        pt: 'Tem certeza de que deseja limpar completamente a parede?',
        de: 'Sind Sie sicher, dass Sie die Wand komplett löschen möchten?',
        fr: 'Êtes-vous sûr de vouloir effacer complètement le mur ?',
        th: 'คุณแน่ใจหรือไม่ว่าต้องการล้างผนังทั้งหมด?',
        ko: '벽을 완전히 지우시겠습니까?',
        zh: '您确定要完全清除墙壁吗？',
        ja: '壁を完全にクリアしてもよろしいですか？',
        hi: 'क्या आप वाकई दीवार को पूरी तरह से साफ़ करना चाहते हैं?'
    },
    btnYesEnter: {
        ru: 'Да (Enter)', en: 'Yes (Enter)', es: 'Sí (Enter)', pt: 'Sim (Enter)',
        de: 'Ja (Enter)', fr: 'Oui (Entrée)', th: 'ใช่ (Enter)', ko: '예 (Enter)', zh: '是 (Enter)', ja: 'はい (Enter)', hi: 'हाँ (Enter)'
    },
    btnNoEsc: {
        ru: 'Нет (Esc)', en: 'No (Esc)', es: 'No (Esc)', pt: 'Não (Esc)',
        de: 'Nein (Esc)', fr: 'Non (Échap)', th: 'ไม่ (Esc)', ko: '아니요 (Esc)', zh: '否 (Esc)', ja: 'いいえ (Esc)', hi: 'नहीं (Esc)'
    },
    alertNothingToUndo: {
        ru: 'Нечего откатывать', en: 'Nothing to undo', es: 'Nada que deshacer', pt: 'Nada para desfazer',
        de: 'Nichts rückgängig zu machen', fr: 'Rien à annuler', th: 'ไม่มีอะไรให้ย้อนกลับ', ko: '되돌릴 내용이 없습니다', zh: '无可撤销', ja: '元に戻すものはありません', hi: 'पूर्ववत करने के लिए कुछ भी नहीं है'
    },
    alertNothingToRedo: {
        ru: 'Некуда возвращать', en: 'Nothing to redo', es: 'Nada que rehacer', pt: 'Nada para refazer',
        de: 'Nichts zu wiederholen', fr: 'Rien à refaire', th: 'ไม่มีอะไรให้ทำซ้ำ', ko: '다시 실행할 내용이 없습니다', zh: '无可重做', ja: 'やり直すものはありません', hi: 'फिर से करने के लिए कुछ भी не है'
    },
    modalEmptyCanTitle: {
        ru: 'Краска закончилась в баллоне №', en: 'Paint finished in can #', es: 'Pintura terminada en el bote #', pt: 'Tinta acabou na lata #',
        de: 'Farbe in der Dose leer #', fr: 'Peinture terminée dans la bombe #', th: 'สีในกระป๋องหมดแล้ว #', ko: '캔의 페인트가 다 떨어졌습니다 #', zh: '喷漆罐已空 #', ja: '缶の塗料がなくなりました #', hi: 'कैन में पेंट खत्म हो गया है #'
    },
    modalEmptyCanRepeat: {
        ru: 'Хотите повторить этот же цвет?', en: 'Do you want to repeat this same color?', es: '¿Quieres repetir este mismo color?', pt: 'Você deseja repetir a mesma cor?',
        de: 'Möchten Sie die gleiche Farbe wiederholen?', fr: 'Voulez-vous répéter la même couleur ?', th: 'คุณต้องการใช้สีเดิมซ้ำหรือไม่?', ko: '같은 색상을 다시 사용하시겠습니까?', zh: '你想重复使用这种颜色吗？', ja: '同じ色を繰り返しますか？', hi: 'क्या आप वही रंग दोहराना चाहते हैं?'
    },
    btnRefillYes: {
        ru: 'Да', en: 'Yes', es: 'Sí', pt: 'Sim', de: 'Ja', fr: 'Oui', th: 'ใช่', ko: '예', zh: '是', ja: 'はい', hi: 'हाँ'
    },
    btnRefillNo: {
        ru: 'Нет', en: 'No', es: 'No', pt: 'Não', de: 'Nein', fr: 'Non', th: 'ไม่', ko: '아니요', zh: '否', ja: 'いいえ', hi: 'नहीं'
    },
    alertPlanRestricted: {
        ru: 'Машина времени будет доступна в тарифе «Стрит-арт художник». Готовься к апгрейду!',
        en: 'Time travel is for "Street-art Artist" pros only. Get ready for the upgrade!',
        es: 'La máquina del tiempo será para pros en el plan "Artista Street-art". ¡Prepárate para subir de nivel!',
        pt: 'A máquina do tempo será só para os prós no plano "Artista Street-art". Prepara-te para o upgrade!',
        de: 'Die Zeitmaschine gibt\'s nur für Profis im "Street-art Künstler"-Tarif. Mach dich bereit für das Upgrade!',
        fr: 'Le voyage dans le temps sera réservé aux pros du plan "Artiste Street-art". Prépare-toi pour l\'upgrade !',
        th: 'ไทม์แมชชีนจะมีให้เฉพาะโปรในแพ็กเกจ "ศิลปินสตรีทอาร์ต" เท่านั้น เตรียมอัปเกรดเลย!',
        ko: '타임머신은 "스트리트 아트 아티스트" 프로들만을 위한 기능입니다. 업그레이드를 기대하세요!',
        zh: '“街头艺术家”专属时间机器即将解锁。准备好升级你的装备了吗？',
        ja: 'タイムトラベルは「ストリートアート・アーティスト」専用의 기능입니다. 업그레이드에 대비하세요!',
        hi: 'टाइम मशीन केवल "स्ट्रीट-आрт कलाकार" पेशेवरों के लिए होगी। अपग्रेड के लिए तैयार रहें!'
    },
    previewModeMultiLabel: {
        ru: 'Тест-драйв набора', en: 'Batch Test Drive', es: 'Prueba por lotes', pt: 'Teste em lote',
        de: 'Batch-Testfahrt', fr: 'Test drive en lot', th: 'การทดสอบชุดสี', ko: '일괄 테스트 드라이브', zh: '批量测试模式', ja: '一括テスト', hi: 'बैच परीक्षण'
    },
    lblFullScreen: {
        ru: 'Фуллскрин', en: 'Full Screen Mode', es: 'Modo pantalla completa', pt: 'Modo tela cheia',
        de: 'Vollbildmodus', fr: 'Mode plein écran', th: 'โหมดเต็มหน้าจอ', ko: '전체 화면 모드', zh: '全屏模式', ja: '全画面モード', hi: 'फुल स्क्रीन मोड'
    },
    hotkeyFullScreen: {
        ru: 'Вкл/Выкл фуллскрин', en: 'Toggle Full Screen Mode', es: 'Alternar pantalla completa', pt: 'Alternar modo tela cheia',
        de: 'Vollbildmodus umschalten', fr: 'Basculer en mode plein écran', th: 'สลับโหมดเต็มหน้าจอ', ko: '전체 화면 모드 전환', zh: '切换全屏模式', ja: '全画面モード切り替え', hi: 'फुल स्क्रीन मोड टॉگل करें'
    },
    hotkeyPanMode: {
        ru: 'Переключение режимов Grab/Spray', en: 'Toggle Grab/Spray modes', es: 'Cambiar modos Grab/Spray', pt: 'Alternar modos Grab/Spray',
        de: 'Grab/Spray-Modus umschalten', fr: 'Basculer entre les modes Grab/Spray', th: 'สลับโหมด Grab/Spray', ko: 'Grab/Spray 모드 전환', zh: '切换抓取/喷涂模式', ja: '移動/スプレーモード切り替え', hi: 'ग्रैब/स्प্রে मोड टॉगल करें'
    },
    usersOnSpot: {
        ru: 'ЮЗЕРОВ НА СПОТЕ', en: 'USERS ON SPOT', es: 'USUARIOS EN EL SPOT', pt: 'USUÁRIOS NO SPOT',
        de: 'USER AM SPOT', fr: 'UTILISATEURS SUR LE SPOT', th: 'ผู้ใช้ที่สปอต', ko: '스팟 유저', zh: '现场用户', ja: 'スポットのユーザー', hi: 'स्पॉट पर उपयोगकर्ता'
    },
    btnExitFullScreen: {
        ru: 'Выйти из полноэкранного режима', en: 'Exit Full Screen', es: 'Salir de pantalla completa', pt: 'Sair da tela cheia',
        de: 'Vollbild verlassen', fr: 'Quitter le plein écran', th: 'ออกจากโหมดเต็มหน้าจอ', ko: '전체 화면 나가기', zh: '退出全屏', ja: '全画面解除', hi: 'फुल स्क्रीन से बाहर निकलें'
    },
    fullScreenOff: {
        ru: 'Фуллскрин: офф', en: 'Full Screen: OFF', es: 'Pantalla completa: OFF', pt: 'Tela cheia: OFF',
        de: 'Vollbild: AUS', fr: 'Plein écran : OFF', th: 'เต็มหน้าจอ: ปิด', ko: '전체 화면: 꺼짐', zh: '全屏：关闭', ja: '全画面：オフ', hi: 'फुल स्क्रीन: बंद'
    },
    lblLanguagePrefix: {
        ru: 'Язык: ', en: 'Language: ', es: 'Idioma: ', pt: 'Idioma: ',
        de: 'Sprache: ', fr: 'Langue : ', th: 'ภาษา: ', ko: '언어: ', zh: '语言：', ja: '言語：', hi: 'भाषा: '
    },
    btnPanMode: {
        ru: 'Перемещение', en: 'Pan Mode', es: 'Modo desplazar', pt: 'Modo panorâmico',
        de: 'Schwenk-Modus', fr: 'Mode panoramique', th: 'โหมดเลื่อน', ko: '이동 모드', zh: '移动模式', ja: '移動モード', hi: 'पैन मोड'
    },
    confirmClear: {
        ru: 'Вы уверены, что хотите очистить холст?', en: 'Are you sure you want to clear the canvas?', es: '¿Estás seguro de que quieres limpiar el lienzo?', pt: 'Tem certeza de que deseja limpar a tela?',
        de: 'Sind Sie sicher, dass Sie die Leinwand löschen möchten?', fr: 'Êtes-vouz sûr de vouloir effacer le canevas ?', th: 'คุณแน่ใจหรือไม่ว่าต้องการล้างผ้าใบ?', ko: '캔버스를 지우시겠습니까?', zh: '您确定要清除画布吗？', ja: 'キャンバスをクリアしてもよろしいですか？', hi: 'क्या आप वाकई कैनवास साफ़ करना चाहते हैं?'
    },
    btnClearCanvas: {
        ru: 'Очистить холст', en: 'Clear Canvas', es: 'Limpiar lienzo', pt: 'Limpar tela',
        de: 'Leinwand löschen', fr: 'Effacer le canevas', th: 'ล้างผ้าใบ', ko: '캔버스 지우기', zh: '清除画布', ja: 'キャンバスをクリア', hi: 'कैनवास साफ़ करें'
    },
    confirmResetColor: {
        ru: 'Сбросить цвет этого инструмента?', en: 'Reset the color of this tool?', es: '¿Restablecer el color de esta herramienta?', pt: 'Redefinir a cor desta ferramenta?',
        de: 'Farbe dieses Werkzeugs zurücksetzen?', fr: 'Réinitialiser la couleur de cet outil ?', th: 'รีเซ็ตสีของเครื่องมือนี้หรือไม่?', ko: '이 도구의 색상을 초기화하시겠습니까?', zh: '重置此工具的颜色吗？', ja: 'このツールの色をリセットしますか？', hi: 'क्या आप इस टूल का रंग रीसेट करना चाहते हैं?'
    },
    btnResetColor: {
        ru: 'Сбросить цвет', en: 'Reset Color', es: 'Restablecer color', pt: 'Redefinir cor',
        de: 'Farbe zurücksetzen', fr: 'Réinitialiser la couleur', th: 'รีเซ็ตสี', ko: '색상 초기화', zh: '重置颜色', ja: '色をリセット', hi: 'रंग रीसेट करें'
    },
    btnDisableGhost: { ru: "Отключить", en: "Disable", es: "Desactivar", pt: "Desativar", de: "Deaktivieren", fr: "Désactiver", th: "ปิดใช้งาน", ko: "비활성화", zh: "禁用", ja: "無効にする", hi: "अक्षम करें" }, autoGhostLabel: {
        ru: 'Контрольный штрих', en: 'Control stroke', es: 'Trazo de control', pt: 'Traço de controle',
        de: 'Kontrollstrich', fr: 'Trait de contrôle', th: 'เส้นควบคุม', ko: '컨트롤 스트로크', zh: '对照笔划', ja: 'コントロールストローク', hi: 'नियंत्रण स्ट्रोक'
    },
    clickToSwitch: {
        ru: 'КЛИК ДЛЯ ПЕРЕХОДА', en: 'CLICK TO SWITCH', es: 'CLIC PARA CAMBIAR', pt: 'CLIQUE PARA MUDAR',
        de: 'KLICKEN ZUM WECHSELN', fr: 'CLIQUER POUR CHANGER', th: 'คลิกเพื่อสลับ', ko: '클릭하여 전환', zh: '点击切换', ja: 'クリックで切り替え', hi: 'बदलने के लिए क्लिक करें'
    },
    currentLoc: {
        ru: 'ТЕКУЩАЯ ЛОКАЦИЯ', en: 'CURRENT LOCATION', es: 'UBICACIÓN ACTUAL', pt: 'LOCALIZAÇÃO ATUAL',
        de: 'AKTUELLER STANDORT', fr: 'EMPLACEMENT ACTUEL', th: 'ตำแหน่งปัจจุบัน', ko: '현재 위치', zh: '当前位置', ja: '現在の場所', hi: 'वर्तमान स्थान'
    },
    hotkeyRedo: {
        ru: 'Повтор действия', en: 'Redo', es: 'Rehacer', pt: 'Refazer',
        de: 'Wiederholen', fr: 'Rétablir', th: 'ทำซ้ำ', ko: '다시 실행', zh: '重做', ja: 'やり直す', hi: 'फिर से करें'
    },
    hotkeySave: {
        ru: 'Мгновенное сохранение', en: 'Instant Save', es: 'Guardado instantáneo', pt: 'Salvamento instantâneo',
        de: 'Sofortiges Speichern', fr: 'Sauvegarde instantanée', th: 'บันทึกทันที', ko: '즉시 저장', zh: '即时保存', ja: '即座に保存', hi: 'तुरंत सहेजें'
    },
    hotkeyHoldPan: {
        ru: 'Перемещение с курсором', en: 'Hold to pan', es: 'Mantener para desplazar', pt: 'Segurar para mover',
        de: 'Halten zum Schwenken', fr: 'Maintenir pour panoramique', th: 'กดค้างเพื่อนําทาง', ko: '홀드하여 이동', zh: '按住以平移', ja: 'ホールドして移動', hi: 'पैन करने के लिए दबाए रखें'
    },
    hotkeysZoomLevels: {
        ru: 'Уровни масштаба (1, 2, 3)', en: 'Zoom levels (1, 2, 3)', es: 'Niveles de zoom (1, 2, 3)', pt: 'Níveis de zoom (1, 2, 3)',
        de: 'Zoom-Stufen (1, 2, 3)', fr: 'Niveaux de zoom (1, 2, 3)', th: 'ระดับการซูม (1, 2, 3)', ko: '확대/축소 수준 (1, 2, 3)', zh: '缩放级别 (1, 2, 3)', ja: 'ズームレベル (1, 2, 3)', hi: 'ज़ूम स्तर (1, 2, 3)'
    },
    hotkeyPresets: {
        ru: 'Пресеты (Q, W, E)', en: 'Presets (Q, W, E)', es: 'Presets (Q, W, E)', pt: 'Predefinições (Q, W, E)',
        de: 'Presets (Q, W, E)', fr: 'Préréglages (Q, W, E)', th: 'พรีเซ็ต (Q, W, E)', ko: '프리셋 (Q, W, E)', zh: '预设 (Q, W, E)', ja: 'プリセット (Q, W, E)', hi: 'प्रीसेट (Q, W, E)'
    },
    hotkeyFlashlight: {
        ru: 'Фонарик Вкл/Выкл', en: 'Flashlight On/Off', es: 'Linterna On/Off', pt: 'Lanterna On/Off',
        de: 'Taschenlampe Ein/Aus', fr: 'Lampe de poche On/Off', th: 'เปิด/ปิดไฟฉาย', ko: '손전등 켜기/끄기', zh: '手电筒 开/关', ja: '懐中電灯 オン/オフ', hi: 'फ्लैशलाइट चालू/बंद'
    },
    hotkeysTitle: {
        ru: 'ГОРЯЧИЕ КЛАВИШИ', en: 'HOTKEYS', es: 'TECLAS DE ACCESO RÁPIDO', pt: 'TECLAS DE ATALHO',
        de: 'HOTKEYS', fr: 'RACCOURCIS CLAVIER', th: 'คีย์ลัด', ko: '단축키', zh: '快捷键', ja: 'ショートカットキー', hi: 'हॉटकीज़'
    },
    btnLetsGo: {
        ru: 'Погнали!', en: "Let's go!", es: '¡Vamos!', pt: 'Vamos lá!',
        de: 'Los geht\'s!', fr: 'C\'est parti !', th: 'ลุยกันเลย!', ko: '가자!', zh: '出发！', ja: '行こう！', hi: 'चलो चलें!'
    },
    changelogInThisVersion: {
        ru: 'В этой версии', en: 'In this version', es: 'En esta versión', pt: 'Nesta versão',
        de: 'In dieser Version', fr: 'Dans cette version', th: 'ในเวอร์ชันนี้', ko: '이번 버전에서', zh: '本次版本', ja: 'このバージョンの内容', hi: 'इस संस्करण में'
    },
    changelogPrevious: {
        ru: 'Было раньше', en: 'Previously', es: 'Anteriormente', pt: 'Anteriormente',
        de: 'Früher', fr: 'Auparavant', th: 'ก่อนหน้านี้', ko: '이전에는', zh: '此前更新', ja: 'これまでの更新', hi: 'पहले'
    },
    changelogNoChanges: {
        ru: 'Нет изменений для этого языка', en: 'No changes for this language', es: 'Sin cambios para este idioma', pt: 'Sem alterações para este idioma',
        de: 'Keine Änderungen für diese Sprache', fr: 'Aucun changement pour cette langue', th: 'ไม่มีการเปลี่ยนแปลงสำหรับภาษานี้', ko: '이 언어에 대한 변경 없음', zh: '此语言无更改', ja: 'この言語への変更はありません', hi: 'इस भाषा के लिए कोई बदलाव नहीं'
    },
    hotkeysLangHint: {
        ru: 'Йо, в менюшке можно менять язык — там есть и твой-родной, и другие',
        en: "Yo, hit the menu to swap the language — yours and others are all there",
        es: "¡Yo! Pásate por el menú y pon tu idioma, hay de todo",
        pt: "Eae, cola no menu pra trocar o idioma — tem o seu e vários otros",
        de: "Yo, check das Menü und stell deine Sprache ein – deine und viele andere sind am Start",
        fr: "Yo, va dans le menu pour changer la langue — la tienne et d'autres sont là",
        th: "โย่ ไปเปลี่ยนภาษาในเมนูได้นะ มีทั้งภาษาคุณและภาษาอื่นๆ ด้วย",
        ko: "요, 메뉴에서 언어 바꿔봐 — 너희 모국어랑 다른 것들도 다 있어",
        zh: "哟，去菜单里换成你的语言吧 — 你的母语和其他语言都在那儿",
        ja: "よお、メニューで言語を切り替えてな — お前の母国語も他にも色々あるぜ",
        hi: "यो, अपनी भाषा बदलने के लिए मेनू पर जाएं — आपकी और दूसरी भाषाएँ भी वहाँ हैं।"
    },
    tonConnectTitle: {
        ru: 'Войти через TON Connect', en: 'Sign in with TON Connect', es: 'Entrar con TON Connect', pt: 'Entrar com TON Connect',
        de: 'Mit TON Connect anmelden', fr: 'Se connecter avec TON Connect', th: 'เข้าสู่ระบบด้วย TON Connect', ko: 'TON Connect으로 로그인', zh: '用 TON Connect 登录', ja: 'TON Connect でサインイン', hi: 'TON Connect से साइन इन करें'
    },
    tonConnectBubble: {
        ru: 'Йо! Авторизация через TON Connect — это безопасно: мы не храним и не хотим хранить твои данные. \n\nКошелёк даёт доп. фичи: откат истории (если напортачил), больше оттенков краски, перегон кусков в NFT и продажу на разных площадках. И ещё много всего. \n\nПочему крипта? Это самый гибкий способ оплаты сейчас. Если вопросы — читай блок авторизации, там всё разжёвано.',
        en: "Yo! TON Connect auth — safe: we don't store your data and don't want to. \n\nWallet gives you extras: undo history (if you mess up), more paint shades, mint pieces as NFTs and sell across platforms. And a lot more. \n\nWhy crypto? It's the most flexible payment method right now. Questions? Read the auth section — everything's explained there.",
        es: '¡Ey! Auth con TON Connect — seguro: no guardamos tus datos ni queremos. \n\nEl wallet te da extras: deshacer historial (si la cagas), más tonos de pintura, convertir piezas en NFT y venderlas en varias plataformas. Y mucho más. \n\n¿Por qué cripto? Es la forma de pago más flexible ahora mismo. ¿Dudas? Lee el bloque de autenticación, ahí está todo explicado.',
        pt: 'Ei! Auth via TON Connect — seguro: não guardamos seus dados e não queremos. \n\nA carteira dá extras: desfazer histórico (se errar), mais tons de tinta, converter peças em NFT e vender em várias plataformas. E muito mais. \n\nPor que cripto? É a forma de pagamento mais flexível agora. Dúvidas? Lê o bloco de autenticação, lá tá tudo explicado.',
        de: 'Yo! TON Connect Auth — sicher: wir speichern deine Daten nicht und wollen das auch nicht. \n\nDas Wallet gibt dir Extras: Verlauf zurücksetzen (wenn du Mist gebaut hast), mehr Farbtöne, Pieces als NFTs prägen und auf verschiedenen Plattformen verkaufen. Und noch viel mehr. Warum Krypto? Es ist gerade der flexibelste Zahlungsweg. Fragen? Lies den Auth-Block, da ist alles erklärt.',
        fr: "Yo ! Auth via TON Connect — sécurisé : on ne stocke pas tes données et on ne veut pas. Le wallet te donne des extras : annuler l'historique (si t'as merdé), plus de nuances de peinture, convertir des pièces en NFT et les vendre sur différentes plateformes. Et encore plein d'autres choses. Pourquoi la crypto ? C'est le moyen de paiement le plus flexible maintenant. Des questions ? Lis le bloc d'auth, tout est expliqué.",
        th: 'โย! Auth ผ่าน TON Connect — ปลอดภัย: เราไม่เก็บและไม่ต้องการเก็บข้อมูลของคุณ กระเป๋าเงินให้ฟีเจอร์เพิ่มเติม: ย้อนประวัติ (ถ้าพลาด), โทนสีเพิ่มเติม, แปลงชิ้นงานเป็น NFT และขายบนหลายแพลตฟอร์ม และอีกมากมาย ทำไมต้องคริปโต? มันคือวิธีชำระเงินที่ยืดหยุ่นที่สุดตอนนี้ มีคำถาม? อ่านบล็อกการยืนยันตัวตน ทุกอย่างอธิบายไว้หมดแล้ว',
        ko: '요! TON Connect 인증 — 안전해: 데이터 저장 안 하고 원하지도 않아. 지갑이 추가 기능을 줘: 히스토리 실행 취소 (실수했을 때), 더 많은 페인트 색조, 조각을 NFT로 민팅하고 여러 플랫폼에서 판매. 그리고 훨씬 더 많은 것들. 왜 크립토? 지금 가장 유연한 결제 수단이야. 질문 있어? 인증 섹션 읽어봐, 거기 다 나와 있어.',
        zh: '哟！TON Connect 认证 — 安全：我们不存储你的数据，也不想存。钱包给你额外功能：撤销历史（如果搞砸了），更多颜料色调，将作品铸造成 NFT 并在各平台出售。还有很多其他东西。为什么用加密货币？这是目前最灵活的支付方式。有疑问？读一下认证板块，那里什么都解释清楚了。',
        ja: 'よお！TON Connect で認証 — 安全：データは保存しないし、したくもない。ウォレットで追加機能が手に入る：履歴をやり直し（ミスした時）、もっと多くの塗料カラー、ピースをNFTにミントして各プラットフォームで販売。他にもたくさん。なぜクリプト？今一番フレキシブルな支払い方法だから。質問は？認証ブロックを読んで、全部説明してある。',
        hi: 'यो! TON Connect से auth — सेफ: हम तुम्हारा डेटा स्टोर नहीं करते और करना भी नहीं चाहते। वॉलेट से extra फीचर्स मिलते हैं: हिस्ट्री अनडू (अगर गड़बड़ हो गई), ज्यादा पेंट शेड्स, पीस को NFT में मिंट करके अलग-अलग प्लेटफॉर्म पर बेचो। और भी बहुत कुछ। क्रिप्टो क्यों? अभी सबसे flexible payment तरीका है। सवाल हैं? auth block पढ़ो, वहाँ सब समझाया गया है।'
    },
    tonConnectBtn: {
        ru: 'Подключить кошелёк', en: 'Connect wallet', es: 'Conectar cartera', pt: 'Conectar carteira',
        de: 'Wallet verbinden', fr: 'Connecter le wallet', th: 'เชื่อมต่อกระเป๋าเงิน', ko: '지갑 연결', zh: '连接钱包', ja: 'ウォレットを接続', hi: 'वॉलेट कनेक्ट करें'
    },
    tonConnectLearnMore: {
        ru: 'Подробнее о TON Connect', en: 'Learn more about TON Connect', es: 'Más sobre TON Connect', pt: 'Saiba mais sobre TON Connect',
        de: 'Mehr über TON Connect', fr: 'En savoir plus sur TON Connect', th: 'เรียนรู้เพิ่มเติมเกี่ยวกับ TON Connect', ko: 'TON Connect에 대해 더 알아보기', zh: '了解更多关于 TON Connect', ja: 'TON Connect について詳しく', hi: 'TON Connect के बारे में अधिक जानें'
    },
    colorBubbleText: {
        ru: 'Свой HEX — это твой личный цвет, которого нет у других. Стоит 1.5 USDT, лежит в твоей коробке навсегда.',
        en: 'Custom HEX is your personal shade — nobody else has it. 1.5 USDT, yours forever.',
        es: 'Tu HEX personalizado es tu color único — nadie más lo tiene. 1.5 USDT, tuyo para siempre.',
        pt: 'HEX customizado é a tua cor única — mais ninguém tem. 1.5 USDT, seu pra sempre.',
        de: 'Dein Custom HEX ist deine persönliche Farbe — niemand sonst hat sie. 1.5 USDT, für immer deins.',
        fr: 'Ton HEX perso est ta couleur unique — personne d\'autre ne l\'a. 1.5 USDT, à toi pour toujours.',
        zh: '自定义 HEX 是你的专属颜色 — 别人没有。1.5 USDT，永久属于你。',
        ko: '커스텀 HEX는 너만의 색깔 — 아무도 안 가진 거. 1.5 USDT, 영원히 네 거.',
        ja: 'カスタム HEX はあなただけの色 — 他の誰も持っていない。1.5 USDT で永遠にあなたのもの。',
        th: 'HEX ของคุณคือสีส่วนตัว — ไม่มีใครมีเหมือนกัน 1.5 USDT เป็นของคุณตลอดไป',
        hi: 'कस्टम HEX तुम्हारा अपना रंग है — किसी के पास नहीं है। 1.5 USDT, हमेशा के लिए तुम्हारा।'
    },
    colorBtnBuy: {
        ru: 'Добавить за 1 GRAM (ex TON)', en: 'Add for 1 GRAM (ex TON)', es: 'Añadir por 1 GRAM (ex TON)', pt: 'Adicionar por 1 GRAM (ex TON)',
        de: 'Für 1 GRAM (ex TON) hinzufügen', fr: 'Ajouter pour 1 GRAM (ex TON)', th: 'เพิ่มในราคา 1 GRAM (ex TON)', ko: '1 GRAM (ex TON)으로 추가', zh: '花 1 GRAM (ex TON) 添加', ja: '1 GRAM (ex TON) で追加', hi: '1 GRAM (ex TON) में जोड़ें'
    },
    colorBuyPending: {
        ru: 'Открываем кошелёк...', en: 'Opening wallet...', es: 'Abriendo cartera...', pt: 'Abrindo carteira...',
        de: 'Wallet wird geöffnet...', fr: 'Ouverture du wallet...', th: 'กำลังเปิดกระเป๋าเงิน...', ko: '지갑 열는 중...', zh: '正在打开钱包...', ja: 'ウォレットを開いています...', hi: 'वॉलेट खुल रहा है...'
    },
    colorBuySuccess: {
        ru: 'Цвет в коробке. Закинул 1 GRAM (ex TON) — получил вечный оттенок.',
        en: 'Color dropped. Paid 1 GRAM (ex TON) — got a shade for life.',
        es: 'Color guardado. Pagaste 1 GRAM (ex TON) — tienes un tono para siempre.',
        pt: 'Cor salva. Pagou 1 GRAM (ex TON) — ganhou um tom pra vida.',
        de: 'Farbe gespeichert. 1 GRAM (ex TON) gezahlt — eine Farbe für immer.',
        fr: 'Couleur ajoutée. 1 GRAM (ex TON) payé — une teinte pour la vie.',
        zh: '颜色入库。花了 1 GRAM (ex TON) — 拿到一个永久色。',
        ko: '색상 추가됨. 1 GRAM (ex TON) 냈어 — 평생 내 색깔.',
        ja: '色を追加しました。1 GRAM (ex TON) 払った — 一生の色を手に入れた。',
        th: 'เพิ่มสีแล้ว จ่าย 1 GRAM (ex TON) — ได้เฉดสีตลอดไป',
        hi: 'रंग जुड़ गया। 1 GRAM (ex TON) दिया — जिंदगी भर का शेड मिला।'
    },
    colorBuyError: {
        ru: 'Что-то пошло не так. Попробуй ещё раз.',
        en: 'Something went wrong. Try again.',
        es: 'Algo salió mal. Inténtalo de nuevo.',
        pt: 'Algo deu errado. Tenta de novo.',
        de: 'Etwas ist schiefgelaufen. Versuch es nochmal.',
        fr: 'Quelque chose a merdé. Réessaie.',
        zh: '出了点问题，再试一次。',
        ko: '뭔가 잘못됐어. 다시 시도해봐.',
        ja: '何かがうまくいかなかった。もう一度試して。',
        th: 'มีบางอย่างผิดพลาด ลองอีกครั้ง',
        hi: 'कुछ गड़बड़ हो गया। दोबारा कोशिश करो।'
    },
    spectatorViewing: {
        ru: 'Смотрят твою трансляцию:',
        en: 'Watching your stream:',
        es: 'Viendo tu transmisión:',
        pt: 'Assistindo sua transmissão:',
        de: 'Zuschauer bei deinem Stream:',
        fr: 'Regardent ta diffusion :',
        zh: '正在围观你的直播：',
        ko: '내 방송 시청 중:',
        ja: '配信を視聴中:',
        th: 'กำลังดูการสตรีมของคุณ:',
        hi: 'आपका प्रसारण देख रहे हैं:'
    },
    spectatorRemaining: {
        ru: 'и ещё',
        en: 'and more',
        es: 'y más',
        pt: 'e mais',
        de: 'und weitere',
        fr: 'et plus',
        zh: '以及其他',
        ko: '외',
        ja: '他',
        th: 'และอื่นๆ',
        hi: 'और अधिक'
    },
    nftStatusLive: {
        ru: 'Изображение со стены',
        en: 'Image from wall',
        es: 'Imagen del muro',
        pt: 'Imagem da parede',
        de: 'Bild von der Wand',
        fr: 'Image du mur',
        zh: '墙面图片',
        ko: '벽에서 가져온 이미지',
        ja: '壁からの画像',
        th: 'ภาพจากกำแพง',
        hi: 'दीवार से छवि'
    },
    nftStatusSaved: {
        ru: '💾 Сохранённые на сервере',
        en: '💾 Saved on server',
        es: '💾 Guardado en el servidor',
        pt: '💾 Salvo no servidor',
        de: '💾 Auf dem Server gespeichert',
        fr: '💾 Sauvegardé sur le serveur',
        zh: '💾 已保存在服务器',
        ko: '💾 서버에 저장됨',
        ja: '💾 サーバーに保存済み',
        th: '💾 บันทึกบนเซิร์ฟเวอร์แล้ว',
        hi: '💾 सर्वर पर सहेजा गया'
    },
    capModalTitle: {
        ru: 'Выбор кэпа',
        en: 'Select Cap',
        es: 'Seleccionar difusor',
        pt: 'Selecionar bico',
        de: 'Cap auswählen',
        fr: 'Choisir le cap',
        zh: '选择喷嘴',
        ko: '캡 선택',
        ja: 'キャップの選択',
        th: 'เลือกหัวสเปรย์',
        hi: 'कैप चुनें'
    },
    'cap_Needle Cap_name': {
        ru: 'Needle Cap',
        en: 'Needle Cap'
    },
    'cap_Needle Cap_sub': {
        ru: '0.2-1 см',
        en: '0.2-1 cm'
    },
    'cap_Needle Cap_desc': {
        ru: 'Тонкие контуры и детали',
        en: 'Fine outlines and details'
    },
    'cap_BIG Roller_name': {
        ru: 'Большой валик',
        en: 'Big Roller'
    },
    'cap_BIG Roller_sub': {
        ru: '15 см',
        en: '15 cm'
    },
    'cap_BIG Roller_desc': {
        ru: 'Большой валик для быстрого покрытия фоновых площадей',
        en: 'Big roller for fast background coverage'
    },
    'cap_MID Roller_name': {
        ru: 'Средний валик',
        en: 'Mid Roller'
    },
    'cap_MID Roller_sub': {
        ru: '10 см',
        en: '10 cm'
    },
    'cap_MID Roller_desc': {
        ru: 'Универсальный валик среднего размера для заливки деталей',
        en: 'Universal medium roller for filling in shapes'
    },
    'cap_SMALL Roller_name': {
        ru: 'Маленький валик',
        en: 'Small Roller'
    },
    'cap_SMALL Roller_sub': {
        ru: '6 см',
        en: '6 cm'
    },
    'cap_SMALL Roller_desc': {
        ru: 'Маленький валик для проработки тонких линий',
        en: 'Small roller for painting fine lines'
    },
    cap_cap_81_female_name: {
        ru: '81 Cap',
        en: '81 Cap'
    },
    cap_cap_81_female_sub: {
        ru: '40-81 см',
        en: '40-81 cm'
    },
    cap_cap_81_female_desc: {
        ru: 'Плоский вертикальный наплыв',
        en: 'Flat vertical spray pattern'
    },
    cap_hardcore_fat_name: {
        ru: 'Hardcore Fat',
        en: 'Hardcore Fat'
    },
    cap_hardcore_fat_sub: {
        ru: '3-12.5 см',
        en: '3-12.5 cm'
    },
    cap_hardcore_fat_desc: {
        ru: 'Специализированный оранжевый кэп от MTN для быстрого закраса',
        en: 'MTN specialized orange fat cap for fast filling'
    },
    cap_skinny_cream_name: {
        ru: 'Skinny Cream',
        en: 'Skinny Cream'
    },
    cap_skinny_cream_sub: {
        ru: '1.1-1.6 см',
        en: '1.1-1.6 cm'
    },
    cap_skinny_cream_desc: {
        ru: 'Стандартный супер-гибкий кэп от MTN 94 для оптимизации распыления',
        en: 'Standard super-flexible MTN 94 cap for optimized spray performance'
    },
    cap_ny_fat_name: {
        ru: 'NY Fat',
        en: 'NY Fat'
    },
    cap_ny_fat_sub: {
        ru: '1-6 см',
        en: '1-6 cm'
    },
    cap_ny_fat_desc: {
        ru: 'Американская насадка известная нам из классических граффити фильмов восьмидесятых',
        en: 'An American nozzle known from classic eighties graffiti movies'
    },
    'cap_Night Quill Slim Dart_name': {
        ru: 'Night Quill Slim Dart',
        en: 'Night Quill Slim Dart'
    },
    'cap_Night Quill Slim Dart_sub': {
        ru: '0.3-2 см',
        en: '0.3-2 cm'
    },
    'cap_Night Quill Slim Dart_desc': {
        ru: 'Ультратонкая насадка для четких линий и максимальной детализации',
        en: 'Ultra-thin nozzle for clean lines and maximum detail'
    },
    'cap_Universal Cap_name': {
        ru: 'Universal Cap',
        en: 'Universal Cap'
    },
    'cap_Universal Cap_sub': {
        ru: '3-5 см',
        en: '3-5 cm'
    },
    'cap_Universal Cap_desc': {
        ru: 'Универсальный кэп для заливки',
        en: 'Universal cap for filling'
    },
    'cap_Fat Cap_name': {
        ru: 'Fat Cap',
        en: 'Fat Cap'
    },
    'cap_Fat Cap_sub': {
        ru: '20-40 см',
        en: '20-40 cm'
    },
    'cap_Fat Cap_desc': {
        ru: 'Жирный наплыв до 40 сантиметров',
        en: 'Fat flare up to 40 centimeters'
    }
};
export function getTranslation(lang, key) {
    if (i18n[key] && i18n[key][lang]) {
        return i18n[key][lang];
    }
    return key;
}
